<div class="information-requests">
  <div class="information-requests__header">
    <h1>Open information requests</h1>
    <div class="information-requests__actions">
      @if (showInviteColleague) {
        <mds-button (click)="createRequestInformation()" ariaLabel="Invite a colleague" type="secondary">
          Invite a Colleague
        </mds-button>
      }
      @if (pendingPCFCount > 0) {
        <mds-button (click)="getBulkResponseOption()" ariaLabel="Respond In Bulk" type="secondary">
          Respond In Bulk
        </mds-button>
      }
      @if (isAllowedToCreateRequests) {
        <mds-button
          (click)="createNewQuestionnaire()"
          [icon]="icons.PLUS"
          [isIconLeft]="true"
          ariaLabel=" Create New Questionnaire"
          type="primary"
        >
          Create New Questionnaire
        </mds-button>
      }
    </div>
  </div>
  <mds-button-toggle
    (change)="onSwitchView($event)"
    [checkedButton]="selectedTab"
    [multiple]="false"
    [name]="'Open information requests'"
    [options]="tabs"
  ></mds-button-toggle>

  @if (selectedTab === InformationRequestTabValues.INCOMING) {
    <section>
      <div>
        <p>Send questionnaires to other Makersite users, who can fill in the gaps in your data.</p>
        <mds-tab (activeTabChange)="onIncomingSubTabChange($event)" [tabs]="requestSubTabs"></mds-tab>
      </div>
      <mds-grid
        (gridReady)="onIncomingGridReady($event)"
        (rowClicked)="onRowClicked($event)"
        [minHeight]="'100%'"
        [overrides]="incomingOverriders"
        [sizeColumnsToFit]="true"
        [themeClass]="'ag-theme-material'"
        [storageKey]="'supplier-dashboard.incoming'"
      ></mds-grid>
    </section>
  }
  @if (selectedTab === InformationRequestTabValues.OUTGOING) {
    <section>
      <div>
        <p>Questionnaires from other Makersite users who are requesting information from you</p>
        <mds-tab (activeTabChange)="onOutgoingSubTabChange($event)" [tabs]="requestSubTabs"></mds-tab>
      </div>
      <mds-grid
        (gridReady)="onOutgoingGridReady($event)"
        [minHeight]="'100%'"
        [overrides]="outgoingOverriders"
        [sizeColumnsToFit]="true"
        [themeClass]="'ag-theme-material'"
        [storageKey]="'supplier-dashboard.outgoing'"
      ></mds-grid>
    </section>
  }
</div>
@if (loading) {
  <mds-loader></mds-loader>
}
